import { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useStore } from '@/hooks/useStore';
import { useCustomer } from '@/context/CustomerContext';
import { StoreHeader, StoreFooter } from '@/components/store';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { storePath, getSubdomain } from "../../utils/storeUtils";

export default function StoreLogin() {
    const { subdomain: paramSubdomain } = useParams();
    const subdomain = paramSubdomain || getSubdomain();
    const navigate = useNavigate();
    const { store, theme, storeAppearance, platformInfo } = useStore(subdomain);
    const { login } = useCustomer();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(store.store_id, formData.email, formData.password);
            toast.success("Welcome back!");

            const params = new URLSearchParams(window.location.search);
            const redirectPath = params.get('redirect') || storePath(subdomain, `/account`);
            navigate(redirectPath);
        } catch (error) {
            toast.error(error.response?.data?.error || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="animate-fade-in">

            <div className="flex-1 flex items-center justify-center p-4">
                <div className="w-full max-w-md bg-white p-8 rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100">
                    <div className="text-center mb-8">
                        <h1 className="text-2xl font-bold text-slate-900">Welcome Back</h1>
                        <p className="text-slate-500 mt-2">Sign in to manage your orders</p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="space-y-2">
                            <Label>Email Address</Label>
                            <Input
                                type="email"
                                value={formData.email}
                                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                required
                                className="h-11 rounded-xl"
                            />
                        </div>
                        <div className="space-y-2">
                            <div className="flex items-center justify-between">
                                <Label>Password</Label>
                                <Link to={storePath(subdomain, `/forgot-password`)} className="text-sm font-medium hover:underline" style={{ color: theme?.primary_color }}>
                                    Forgot password?
                                </Link>
                            </div>
                            <Input
                                type="password"
                                value={formData.password}
                                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                required
                                className="h-11 rounded-xl"
                            />
                        </div>

                        <Button
                            type="submit"
                            disabled={loading}
                            className="w-full h-11 rounded-xl font-bold"
                            style={{ backgroundColor: theme?.primary_color || '#4F46E5' }}
                        >
                            {loading ? 'Signing In...' : 'Sign In'}
                        </Button>
                    </form>

                    <p className="text-center mt-6 text-sm text-slate-500">
                        Don't have an account?{' '}
                        <Link to={storePath(subdomain, `/register`)} className="font-bold hover:underline" style={{ color: theme?.primary_color }}>
                            Create one
                        </Link>
                    </p>
                </div>
            </div>

        </div>
    );
}
